export default __webpack_public_path__ + "static/media/abstract-orb.1c9d11c3.png";